import FetchWebAPIUtils from 'utils/FetchWebAPIUtils';

export default function (request) {
  return FetchWebAPIUtils.getElasticSearchResults(request);
}
